import React from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { SlackIntegrationGraphCardMorph } from '../components/SlackIntegrationGraphCardMorph';
import { useScreenInit } from '../useScreenInit.js';
// Experimental page: replicates the first two beats of the home page (the
// chat-box composer hero + the "Giga plugs into your world → Lives inside your
// chats" scroll animation), but with a refined hand-off where the squared-off
// Giga mark grows its own container card and that card zooms out into the chat
// panel. Lives at /chat-transition so the live home page stays untouched.
export function ChatTransition() {
  useScreenInit();
  return <>
      <HowItWorksConnections mode="hero" data-id="element-6286" data-mp="l9u4tm8s9juz" />
      <SlackIntegrationGraphCardMorph data-id="element-6287" data-mp="l8srfb4aola3" />
    </>;
}